import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { of, switchMap, tap } from 'rxjs';

import { AppLoaderService } from 'src/app/core/services/app-loader/app-loader.service';
import { AppSessionService } from 'src/app/core/services/app-session/app-session.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { NoticeConfidentialityService } from 'src/app/core/services/notice-confidentiality/notice-confidentiality.service';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { Setting } from 'src/app/core/models/setting';
import { SettingsService } from 'src/app/core/services/settings/settings.service';

@Component({
  selector: 'shared-notice-confidentiality',
  templateUrl: './notice-confidentiality.component.html'
})
export class NoticeConfidentialityComponent {

  constructor(
    private readonly _appLoaderService: AppLoaderService,
    private readonly _appSessionService: AppSessionService,
    private readonly _authService: AuthService,
    private readonly _noticeConfidentialityService: NoticeConfidentialityService,
    private readonly _notificationService: NotificationService,
    private readonly _router: Router,
    private readonly _settingsService: SettingsService,
  ) { }

  public get setting(): Setting | undefined {
    return this._settingsService.setting;
  }

  /**
   * Reload when user accept notice confidentiality.
   */
  public acceptNoticeConfidentiality(): void {
    this._appLoaderService.startLoading();

    this._noticeConfidentialityService
      .acceptNoticeConfidentiality$()
      .pipe(
        switchMap(() => {
          return of({...this._appSessionService.session!})
        })
      )
      .subscribe({
        next: (response) => {
          response.noticeConfidentialityAccepted = true;
          this._appSessionService.setSession(response);
          this._router.navigateByUrl('/');
          this._appLoaderService.stopLoading();
        },
        error: ({error}) => {
          this._appLoaderService.stopLoading();
          this._notificationService.warning('Ocurrio un error', `No fue posible aceptar el aviso de confidencialidad.${error.errors}`);
        }
      });
  }
}